import React from "react";
import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const SelectComponent = ({
  component,
  isEditingLabel,
  labelValue,
  onLabelChange,
  onLabelBlur,
  onLabelKeyDown,
  mode,
  value,
  onChange,
  readOnly,
}) => {
  // Aplicar estilos
  const getStyle = () => {
    const style = component.style || {};
    return {
      backgroundColor: style.backgroundColor || "transparent",
      borderRadius: style.borderRadius ? `${style.borderRadius}px` : "4px",
      border:
        mode === "response"
          ? "none"
          : style.borderWidth
            ? `${style.borderWidth}px solid ${style.borderColor || "#ccc"}`
            : "1px solid #ccc",
      padding: style.padding
        ? `${style.padding.top || 0}px ${style.padding.right || 0}px ${style.padding.bottom || 0}px ${style.padding.left || 0}px`
        : "8px",
      margin: style.margin
        ? `${style.margin.top || 0}px ${style.margin.right || 0}px ${style.margin.bottom || 0}px ${style.margin.left || 0}px`
        : "0",
      boxShadow: style.shadow?.enabled
        ? `${style.shadow.offsetX || 0}px ${style.shadow.offsetY || 0}px ${style.shadow.blur || 4}px ${style.shadow.color || "rgba(0,0,0,0.2)"}`
        : "none",
    };
  };

  const getTextStyle = () => {
    const textStyle = component.style?.textStyle || {};
    return {
      fontSize: textStyle.fontSize ? `${textStyle.fontSize}px` : "14px",
      fontWeight: textStyle.fontWeight || "normal",
      color: textStyle.color || "#000000",
      textAlign: textStyle.textAlign || "left",
      fontFamily: textStyle.fontFamily || "inherit",
    };
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: 0.5,
        ...getStyle(),
      }}
    >
      {isEditingLabel ? (
        <InputLabel>
          <input
            value={labelValue}
            onChange={onLabelChange}
            onBlur={onLabelBlur}
            onKeyDown={onLabelKeyDown}
            autoFocus
            style={{ width: "100%" }}
          />
        </InputLabel>
      ) : (
        <Typography
          variant="body2"
          sx={{
            fontWeight: "medium",
            color: "text.primary",
            mb: 0.5,
            ...getTextStyle(),
          }}
        >
          {component.label}
          {component.required && (
            <Typography component="span" sx={{ color: "error.main", ml: 0.5 }}>
              *
            </Typography>
          )}
        </Typography>
      )}
      <FormControl fullWidth size="small">
        <Select
          value={value || ""}
          onChange={(e) => onChange && onChange(e.target.value)}
          displayEmpty
          disabled={!!readOnly}
          sx={{
            "& .MuiInputBase-input": {
              ...getTextStyle(),
            },
          }}
        >
          <MenuItem value="" disabled>
            <em>{component.placeholder || "Selecciona..."}</em>
          </MenuItem>
          {(component.options || []).map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectComponent;
